import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { isString } from 'lodash';
import { useState } from 'react';
import { AxiosError } from 'axios';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const updateSalesCreditNoteRegister = async ({ id, payload }) => {
  const response = await apiClient.put(`/document-registers/sales-credit-notes/${id}`, payload);
  return response.data;
};

export const useUpdateSalesCreditNoteRegisterHandler = ({ onSuccess }) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { salesInvoiceRegister } = useTranslatedMessages();
  const messages = salesInvoiceRegister?.handlers || {};
  const [error, setError] = useState(null);

  const mutation = useMutation({
    mutationFn: updateSalesCreditNoteRegister,
    onSuccess: (data, variables) => {
      dispatch(
        showSnackbar({
          message: messages.update_credit_note_success ?? 'Credit note register entry updated successfully.',
        }),
      );
      queryClient.invalidateQueries({ queryKey: ['sales-credit-note-register'] });
      onSuccess && onSuccess(data, variables);
      setError(null);
    },
    onError: (err) => {
      if (err instanceof AxiosError) {
        if (err.response?.status === 400) {
          setError(err.response.data?.errors);
          return;
        }
        dispatch(
          showSnackbar({
            message: err.response?.data?.message ?? err.message ?? 'An error occurred.',
            severity: 'error',
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: isString(err.message) ? err.message : JSON.stringify(err.message),
            severity: 'error',
          }),
        );
      }
    },
  });

  const onSubmit = async ({ id, payload }) => {
    mutation.mutate({ id, payload });
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onSubmit,
  };
};
